import { render, staticRenderFns } from "./InformationSystem.vue?vue&type=template&id=4858cc65"
import script from "./InformationSystem.vue?vue&type=script&lang=js"
export * from "./InformationSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports